import {
	PageContainer as PageContainerMoznUI,
	PageHeader,
	PageRoot,
} from "@moznsystems/mozn-ui";
import clsx from "clsx";
import type { FC, PropsWithChildren } from "react";
import { useNavigate } from "react-router-dom";

type PageContainerProps = {
	title?: string;
	backBtn?: boolean;
	className: string;
	state?: unknown;
	route?: string;
	withBackground?: boolean;
	blockClassName?: string;
	onBack?: () => void;
};

const PageContainer: FC<PropsWithChildren<PageContainerProps>> = ({
	children,
	title = "",
	backBtn = false,
	state,
	route,
	className,
	withBackground = false,
	blockClassName = "",
	onBack,
}) => {
	const navigate = useNavigate();

	const navigateBack = () => {
		if (onBack) {
			onBack();
		} else if (route && state) {
			navigate(route, { state });
		} else if (route) {
			navigate(route);
		} else {
			navigate(-1);
		}
	};

	return (
		<PageRoot className={className}>
			{backBtn ? (
				<PageHeader title={title} backButton={navigateBack} />
			) : (
				<PageHeader title={title} />
			)}
			<PageContainerMoznUI
				className={clsx(blockClassName, { block_list: withBackground })}
			>
				{children}
			</PageContainerMoznUI>
		</PageRoot>
	);
};

export { PageContainer };
